import { CONNECTOR_ROUTING_ORTHOGONAL_AUTO } from '../utils/DefaultsManager';

export const ConnectorRouting = {
  ROUTING_STRAIGHT: 0,
  ROUTING_BEZIER: 10,
  ROUTING_ORTHOGONAL_AUTO: CONNECTOR_ROUTING_ORTHOGONAL_AUTO, // Auto-routing.
  ROUTING_ORTHOGONAL_MANUAL: 30, // Orthogonal manual routing.
} as const;

export type TConnectorRouting =
  (typeof ConnectorRouting)[keyof typeof ConnectorRouting];
